import { memo } from 'react';
import { Box, Typography, colors, theme, IconArrowForward } from '@capitalise/ui-design-system';
import experianLogo from 'assets/images/experian.png';
import FundingSearchGuy from 'assets/svgs/businessMenu/new-funding-search-guy.svg';

import PropTypes from 'prop-types';
import { useAuthContext } from 'HOC/withAuth';
import { UserType } from 'enums/user-type';
import { Analytics } from 'utils/Analytics';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';

const FundingSearchBanner = ({
  title,
  bannerCallback,
  baseColor,
  image,
  imageMobile,
  analytic,
}) => {
  const { user } = useAuthContext();
  const { isMobile } = useMediaQuery();

  if (!title) {
    return null;
  }

  return (
    <Box width="100%" px="xsmall">
      {!!user?.id && (
        <Box gridGap="4xsmall" display="flex" flexDirection="column">
          <Box width="100%">
            <Box
              position="relative"
              borderRadius={theme.sizes['3xsmall']}
              height={isMobile ? '96px' : '144px'}
              background={`linear-gradient(0, ${colors[`${baseColor}-500`]}  0%, ${
                colors[`${baseColor}-300`]
              }  100%)`}
              display="flex"
              flexDirection="row"
            >
              <Box>{isMobile ? imageMobile : image}</Box>
              <Box
                flex="1"
                py="4xsmall"
                pr="4xsmall"
                cursor="pointer"
                onClick={() => {
                  Analytics.track(analytic.category, analytic.subCategory, {
                    extraParams: {
                      ...analytic.extraParams,
                      userType: UserType.business,
                      companyType: user?.company?.type,
                      membership: user?.membership?.level?.name,
                    },
                  });
                  bannerCallback();
                }}
              >
                <Box typography="heading-16" color="white">
                  {title}
                  {isMobile && (
                    <Box display="inline-flex" position="fixed" pl="xtiny">
                      <IconArrowForward color="white" />
                    </Box>
                  )}
                </Box>

                {!isMobile && (
                  <Typography size="heading-16" color="white" pt="xtiny">
                    <IconArrowForward color="white" />
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
          <Box display="flex" justifyContent="center">
            <img src={experianLogo} alt="powered by experian" />
          </Box>
        </Box>
      )}
    </Box>
  );
};

FundingSearchBanner.propTypes = {
  bannerCallback: PropTypes.func,
  baseColor: PropTypes.string,
  image: PropTypes.node,
  imageMobile: PropTypes.node,
  title: PropTypes.string,
  analytic: PropTypes.shape({
    category: PropTypes.string,
    subCategory: PropTypes.string,
    extraParams: PropTypes.object,
  }),
};

FundingSearchBanner.defaultProps = {
  baseColor: 'green',
  image: <FundingSearchGuy />,
};

export default memo(FundingSearchBanner);
